<template>
    <div class="hero">
        <div class="fadeOff">
            <div class="tiles">
                <div class="col">
                    <img class="tile"
                        src="/assets/img/landing/l-1.jpg"/>
                    <img class="tile"
                        src="/assets/img/landing/l-2.jpg"/>
                    <img class="tile"
                        src="/assets/img/landing/l-3.jpg"/>
                </div>

                <div class="col">
                    <img class="tile"
                        src="/assets/img/landing/c-1.jpg"/>
                    <img class="tile"
                        src="/assets/img/landing/c-2.jpg"/>
                    <img class="tile"
                        src="/assets/img/landing/c-3.jpg"/>
                </div>

                <div class="col">
                    <img class="tile"
                        src="/assets/img/landing/r-1.jpg"/>
                    <img class="tile"
                        src="/assets/img/landing/r-2.jpg"/>
                    <img class="tile"
                        src="/assets/img/landing/r-3.jpg"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Hero'
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .hero {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 0;
        padding: 6rem 0;
    }

    .fadeOff {
        position: relative;
        max-width: 72rem;
        width: 100%;
        animation: fadeOff 2s ease-in-out;
        animation-delay: 2.5s;
        transform-origin: center;
        animation-fill-mode: forwards;
        animation-iteration-count: 1;
        z-index: -1;
    }

    @keyframes fadeOff {
        0% {
            transform: scale(1) translateY(0);
            opacity: 1;
        }

        100% {
            transform: scale(5) translateY(-15rem);
            opacity: 0;
        }
    }

    .tiles {
        width: 100%;
        display: flex;
        position: relative;
        overflow: hidden;
        border-radius: 1rem;
        animation: rotateTiles 2s ease-in-out;
        transform-origin: center;
    }

    @keyframes rotateTiles {
        0% {
            transform: rotate3d(1, 1, 1, -40deg);
        }

        100% {
            transform: rotate3d(0, 0, 0, 0deg);
        }
    }

    .tile:nth-child(1) {
        animation: fade-delay-1 2s ease-in-out;
    }

    .tile:nth-child(2) {
        animation: fade 2s ease-in-out;
    }

    .tile:nth-child(3) {
        animation: fade-delay-2 2s ease-in-out;
    }

    .col:nth-child(1) {
        animation: fade-delay-1 2s ease-in-out;
    }

    .col:nth-child(2) {
        animation: fade 2s ease-in-out;
    }

    .col:nth-child(3) {
        animation: fade-delay-2 2s ease-in-out;
    }

    @keyframes fade {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes fade-delay-1 {
        0% {
            opacity: 0;
        }

        33% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes fade-delay-2 {
        0% {
            opacity: 0;
        }

        66% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .gradient {
        content: '';
        position: absolute;
        width: 100%;
        height: 50%;
        bottom: 0;
        left: 0;
        background: var(--gradient-black-0-black-1);
    }

    .col {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-right: 1rem;

        &:last-of-type {
            margin: 0;
        }
    }

    .tile {
        width: 100%;
        border-radius: 1rem;
        margin-bottom: 1rem;

        &:last-of-type {
            margin: 0;
        }
    }

    .utilityWrapper {
        position: absolute;
        left: 50%;
        top: 12%;
        transform: translateX(-50%) scale(0.7);
        max-width: 68rem;
        height: 32rem;
        width: 100%;
        z-index: 1;
    }

    .leading {
        height: 100%;
    }

    @media all and (max-width: 1024px) {
        .utilityWrapper {
            top: 15%;
            height: auto;
        }
    }

    @media all and (max-width: 720px) {
        .utilityWrapper {
            width: 48rem;
        }
    }

    @media all and (max-width: 560px) {
        .utilityWrapper {
            top: -2%;
            width: 36rem;
            transform: translateX(-50%) scale(0.55);
        }
    }
</style>